<template>
  <div data-cy="base-time-picker">
    <v-dialog ref="dialog" v-model="showTimePicker" persistent width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field
            v-model="clock"
            prepend-inner-icon="mdi-clock-outline"
            readonly
            v-on="on"
            :disabled="disabled"
            :rules="valueRules"
            data-cy="open-dialog-btn"
        ></v-text-field>
      </template>
      <!-- TODO: MPDT210068-3704: Auf Minuten anpassen - Done AW-->
      <v-time-picker
          v-if="showTimePicker"
          v-model="time"
          format="24hr"
          data-cy="dialog-open-time-picker"
      >
        <v-spacer></v-spacer>
        <v-btn
            text
            color="primary"
            @click="showTimePicker = false"
            data-cy="btn-cancel"
        >{{ i18n.t("_Cancel") }}</v-btn
        >
        <v-btn text color="primary" @click="changedTime()" data-cy="btn-okay">{{
            i18n.t("_Okay")
          }}</v-btn>
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import i18n from "../helper/i18n"

export default {
  props: {
    value: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      time: this.clock,
      showTimePicker: false,
      valueRules: [(v) => !!v || "Value is required"],
      i18n:i18n
    };
  },
  mounted() {
    this.time = this.clock;
  },
  methods: {
    changedTime() {
      this.showTimePicker = false;
      var moTime = moment(this.time, "HH:mm");
      var timeInMs = moTime.hours() * 3600000 + moTime.minutes() * 60000;
      this.$emit("input", timeInMs);
    },
  },
  computed: {
    clock() {
      return moment(this.value - 3600000, "x").format("HH:mm");
    },
  },
};
</script>
